import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueHtmlToPaper from "vue-html-to-paper";
import i18n from "@/plugins/i18n";
import _ from "lodash";
import JsonExcel from "vue-json-excel";
import PAlert from "./components/common/PAlert.vue"

import { VueMaskFilter } from "v-mask";
Vue.filter("VMask", VueMaskFilter);

Object.defineProperty(Vue.prototype, "_", { value: _ });

const options = {
    name: "_blank",
    styles: ["https://stackpath.bootstrapcdn.com/bootstrap/4.2.1/css/bootstrap.min.css", "https://fonts.googleapis.com/css2?family=Cairo&display=swap"],
};

Vue.use(VueHtmlToPaper, options);
Vue.component("downloadExcel", JsonExcel);
Vue.component("PAlert", PAlert)

Vue.mixin({
    methods: {
        copyObject: (object) => JSON.parse(JSON.stringify(object)),
    },
});

Vue.config.productionTip = false;
Vue.config.keyCodes = {
    ctrl: 17,
    enter: 13,
    delete: 68,
    n: 78,
    q: 81,
};

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
